import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import { profile } from "../data/content";

const links = [
  { id: 'home', label: 'Início' },
  { id: 'experiencia', label: 'Experiência' },
  { id: 'projetos', label: 'Projetos' },
  { id: 'stack', label: 'Stack' },
  { id: 'servicos', label: 'Serviços' },
];

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  return (
    <Navbar expand="lg" collapseOnSelect className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home" className="brand-text">
          Pedro<span>Pampolini</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label="Abrir menu">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {links.map(({ id, label }) => (
              <Nav.Link
                key={id}
                href={`#${id}`}
                className={activeLink === id ? 'active navbar-link' : 'navbar-link'}
                onClick={() => setActiveLink(id)}
              >
                {label}
              </Nav.Link>
            ))}
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a target="_blank" rel="noopener noreferrer" href={profile.linkedin} aria-label="LinkedIn"><img src={navIcon1} alt="" /></a>
              <a target="_blank" rel="noopener noreferrer" href={profile.github} aria-label="GitHub"><img src={navIcon2} alt="" /></a>
              <a target="_blank" rel="noopener noreferrer" href={profile.instagram} aria-label="Instagram"><img src={navIcon3} alt="" /></a>
            </div>
            <a href="#contato">
              <button className="vvd"><span>Entre em contato</span></button>
            </a>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
